import { createContext, useContext, useState } from "react";

export const translations = {
  ro: {
    nav: { how: "Cum funcționează", why: "De ce noi", check: "Verifică zborul", faq: "Întrebări", contact: "Contact", admin: "Admin" },
    lang: "EN",
    hero: {
      badge: "Sprijin în limba română · UK",
      title: "Zborul întârziat sau anulat? Te ajutăm să obții compensația.",
      subtitle: "Te ajutăm să obții compensația care ți se cuvine — până la £520 per pasager. Vorbim româna, ne ocupăm de acte și de compania aeriană în locul tău.",
      cta: "Verifică gratuit zborul",
      cta2: "Vorbește cu noi",
      stat1: "£520", stat1l: "Compensație maximă / pasager",
      stat2: "3 ani", stat2l: "Poți solicita retroactiv",
      stat3: "0 £", stat3l: "Fără câștig, fără plată",
    },
    trust: {
      title: "Nu trebuie să știi engleză sau legile. Ne ocupăm noi.",
      items: [
        { t: "Fără câștig, fără plată", d: "Nu plătești nimic în avans. Percepem un comision doar dacă îți recuperăm banii." },
        { t: "100% în limba română", d: "Îți explicăm totul pe înțeles, fără termeni juridici complicați." },
        { t: "Ne ocupăm de tot", d: "Completăm actele și comunicăm cu compania aeriană în locul tău." },
      ],
    },
    how: {
      title: "Cum funcționează",
      subtitle: "Trei pași simpli până la banii tăi.",
      steps: [
        { t: "Trimite detaliile zborului", d: "Completează formularul în 2 minute. E gratuit și fără obligații." },
        { t: "Verificăm eligibilitatea", d: "Analizăm cazul tău conform legislației UK/UE și îți spunem cât poți primi." },
        { t: "Rezultatul cererii", d: "Dacă cererea este aprobată, primești compensația, iar noi reținem doar comisionul agreat." },
      ],
    },
    why: {
      title: "De ce pasagerii români ne aleg",
      items: [
        { t: "Sprijin uman, real", d: "O persoană reală care vorbește româna te ghidează la fiecare pas." },
        { t: "Fără hârtii englezești", d: "Nu te lupta cu formulare complicate. Le completăm noi pentru tine." },
        { t: "Zboruri din/către UK", d: "Întârzieri peste 3 ore, anulări sau refuz la îmbarcare." },
        { t: "Transparență totală", d: "Fără costuri ascunse. Știi din start ce comision percepem." },
      ],
    },
    elig: {
      title: "Verifică-ți gratuit zborul",
      subtitle: "Completează detaliile și îți spunem dacă ai dreptul la compensație.",
      full_name: "Nume complet", email: "Email", phone: "Telefon / WhatsApp",
      flight_number: "Număr zbor (ex: FR1234)", flight_date: "Data zborului",
      departure: "Aeroport plecare", arrival: "Aeroport sosire", airline: "Compania aeriană",
      issue: "Ce s-a întâmplat?", issue_delay: "Întârziere", issue_cancel: "Anulare", issue_denied: "Refuz la îmbarcare",
      delay: "Durata întârzierii", delay1: "Sub 3 ore", delay2: "3-4 ore", delay3: "Peste 4 ore",
      details: "Detalii suplimentare (opțional)",
      submit: "Trimite verificarea", sending: "Se trimite...",
      success: "Mulțumim! Am primit cererea ta și te contactăm curând.",
      fee_title: "Verificare gratuită",
      fee1: "Nu plătești nimic în avans.",
      fee2: "Dacă obținem compensația pentru tine, comisionul ZborHelp este de 40%.",
      fee3: "Dacă nu obținem compensație, nu plătești nimic.",
      consent1: "Confirm că informațiile trimise sunt corecte, după cunoștința mea.",
      consent2: "Sunt de acord ca ZborHelp să mă contacteze prin telefon, email sau WhatsApp în legătură cu această cerere.",
      consent3: "Înțeleg că trimiterea formularului nu garantează obținerea unei compensații.",
      consent4_pre: "Sunt de acord cu ",
      terms: "Termenii și Condițiile",
      and: " și ",
      privacy: "Politica de Confidențialitate",
      consent_error: "Te rugăm să bifezi toate căsuțele obligatorii.",
      trust_note: "Datele tale sunt folosite doar pentru verificarea și procesarea cererii tale. Nu vindem datele tale și nu te contactăm pentru alte servicii fără acordul tău.",
      important: "Important: ZborHelp nu poate garanta obținerea unei compensații. Fiecare cerere depinde de circumstanțele zborului, motivul întârzierii/anulării și răspunsul companiei aeriene.",
    },
    est: {
      title: "Estimează-ți compensația",
      subtitle: "Alege distanța zborului pentru o estimare orientativă.",
      distance: "Distanța zborului",
      d1: "Scurtă — sub 1.500 km",
      d2: "Medie — 1.500–3.500 km",
      d3: "Lungă — peste 3.500 km",
      gross: "Compensație estimată",
      fee: "Comision ZborHelp (40%)",
      net: "Estimare după comision",
      note: "Estimarea este orientativă. Suma finală depinde de distanța zborului, durata întârzierii, motivul întârzierii/anulării și acceptarea cererii de către compania aeriană.",
    },
    faq: {
      title: "Întrebări frecvente",
      items: [
        { q: "Cât poate fi compensația?", a: "În funcție de distanță și de durata întârzierii, compensația poate ajunge până la £520 per pasager, conform reglementărilor UK261 / EC261." },
        { q: "Cât mă costă?", a: "Nimic în avans. Lucrăm pe principiul „fără câștig, fără plată” — percepem un comision doar dacă recuperăm banii pentru tine." },
        { q: "Pentru ce zboruri se aplică?", a: "Zboruri care pleacă dintr-un aeroport UK/UE sau operate de o companie UK/UE, cu întârzieri peste 3 ore, anulări sau refuz la îmbarcare." },
        { q: "Pentru cât timp în urmă pot solicita compensație?", a: "În general, poți solicita compensație pentru zboruri din ultimii 3 ani." },
        { q: "Trebuie să vorbesc engleză?", a: "Nu. Ne ocupăm noi de toată comunicarea și actele în engleză. Tu vorbești cu noi în română." },
      ],
    },
    contact: {
      title: "Ai o întrebare? Scrie-ne.",
      subtitle: "Îți răspundem în limba română, cât mai repede posibil.",
      full_name: "Nume complet", email: "Email", phone: "Telefon / WhatsApp", message: "Mesajul tău",
      submit: "Trimite mesajul", sending: "Se trimite...",
      success: "Mulțumim! Mesajul tău a fost trimis. Te contactăm curând.",
      phone_label: "Telefon", wa_label: "WhatsApp", email_label: "Email",
    },
    footer: { tagline: "Sprijin în limba română pentru compensații de zbor în UK.", rights: "Toate drepturile rezervate.", disclaimer: "ZborHelp nu este o firmă de avocatură. Oferim servicii de asistență pentru reclamații de compensare a zborurilor.", support: "ZborHelp este un serviciu de suport administrativ pentru cereri de compensație privind zboruri întârziate, anulate sau refuz la îmbarcare.", terms: "Termeni și Condiții", privacy: "Politica de Confidențialitate", cookies: "Politica Cookies" },
    wa: { float: "Scrie-ne pe WhatsApp", msg: "Bună, vreau să verific dacă pot primi compensație pentru un zbor întârziat sau anulat." },
    validation: "Te rugăm să completezi câmpurile obligatorii.",
    error: "A apărut o eroare. Te rugăm încearcă din nou.",
  },
  en: {
    nav: { how: "How it works", why: "Why us", check: "Check flight", faq: "FAQ", contact: "Contact", admin: "Admin" },
    lang: "RO",
    hero: {
      badge: "Romanian-speaking support · UK",
      title: "Flight delayed or cancelled? We get your money back.",
      subtitle: "We help you claim the compensation you deserve — up to £520 per passenger. We speak Romanian and handle the paperwork and the airline for you.",
      cta: "Check your flight free",
      cta2: "Talk to us",
      stat1: "£520", stat1l: "Max compensation / passenger",
      stat2: "3 years", stat2l: "How far back you can claim",
      stat3: "£0", stat3l: "No win, no fee",
    },
    trust: {
      title: "You don't need English or legal knowledge. We handle it.",
      items: [
        { t: "No win, no fee", d: "You pay nothing upfront. We only charge a fee if we recover your money." },
        { t: "100% in Romanian", d: "We explain everything clearly, with no confusing legal jargon." },
        { t: "We handle everything", d: "We complete the paperwork and deal with the airline for you." },
      ],
    },
    how: {
      title: "How it works",
      subtitle: "Three simple steps to your money.",
      steps: [
        { t: "Send your flight details", d: "Fill in the form in 2 minutes. It's free and with no obligation." },
        { t: "We check eligibility", d: "We assess your case under UK/EU law and tell you how much you can claim." },
        { t: "Claim outcome", d: "If your claim is approved, you receive the compensation and we keep only the agreed fee." },
      ],
    },
    why: {
      title: "Why Romanian passengers choose us",
      items: [
        { t: "Real human support", d: "A real Romanian-speaking person guides you at every step." },
        { t: "No English paperwork", d: "Don't fight with complicated forms. We complete them for you." },
        { t: "Flights to/from the UK", d: "Delays over 3 hours, cancellations or denied boarding." },
        { t: "Full transparency", d: "No hidden costs. You know our fee from the start." },
      ],
    },
    elig: {
      title: "Check your flight for free",
      subtitle: "Fill in the details and we'll tell you if you're entitled to compensation.",
      full_name: "Full name", email: "Email", phone: "Phone / WhatsApp",
      flight_number: "Flight number (e.g. FR1234)", flight_date: "Flight date",
      departure: "Departure airport", arrival: "Arrival airport", airline: "Airline",
      issue: "What happened?", issue_delay: "Delay", issue_cancel: "Cancellation", issue_denied: "Denied boarding",
      delay: "Length of delay", delay1: "Under 3 hours", delay2: "3-4 hours", delay3: "Over 4 hours",
      details: "Additional details (optional)",
      submit: "Submit check", sending: "Sending...",
      success: "Thank you! We received your request and will contact you soon.",
      fee_title: "Free check",
      fee1: "You pay nothing upfront.",
      fee2: "If we recover your compensation, the ZborHelp fee is 40%.",
      fee3: "If we don't recover any compensation, you pay nothing.",
      consent1: "I confirm that the information submitted is correct to the best of my knowledge.",
      consent2: "I agree that ZborHelp may contact me by phone, email or WhatsApp regarding this request.",
      consent3: "I understand that submitting this form does not guarantee any compensation.",
      consent4_pre: "I agree to the ",
      terms: "Terms & Conditions",
      and: " and ",
      privacy: "Privacy Policy",
      consent_error: "Please tick all the required boxes.",
      trust_note: "Your data is used only to check and process your request. We do not sell your data and will not contact you for other services without your consent.",
      important: "Important: ZborHelp cannot guarantee that compensation will be obtained. Each claim depends on the flight circumstances, the reason for the delay/cancellation and the airline's response.",
    },
    est: {
      title: "Estimate your compensation",
      subtitle: "Choose the flight distance for a rough estimate.",
      distance: "Flight distance",
      d1: "Short — under 1,500 km",
      d2: "Medium — 1,500–3,500 km",
      d3: "Long — over 3,500 km",
      gross: "Estimated compensation",
      fee: "ZborHelp fee (40%)",
      net: "Estimate after fee",
      note: "This is a rough estimate. The final amount depends on the flight distance, the length of the delay, the reason for the delay/cancellation and the airline's acceptance of the claim.",
    },
    faq: {
      title: "Frequently asked questions",
      items: [
        { q: "How much can I claim?", a: "Depending on distance and delay length, compensation can be up to £520 per passenger under UK261 / EC261 regulations." },
        { q: "What does it cost?", a: "Nothing upfront. We work on a no-win, no-fee basis — we only charge a fee if we recover your money." },
        { q: "Which flights qualify?", a: "Flights departing from a UK/EU airport or operated by a UK/EU airline, with delays over 3 hours, cancellations or denied boarding." },
        { q: "How far back can I claim?", a: "You can usually claim for flights within the last 3 years." },
        { q: "Do I need to speak English?", a: "No. We handle all English communication and paperwork. You talk to us in Romanian." },
      ],
    },
    contact: {
      title: "Have a question? Write to us.",
      subtitle: "We reply in Romanian, as quickly as possible.",
      full_name: "Full name", email: "Email", phone: "Phone / WhatsApp", message: "Your message",
      submit: "Send message", sending: "Sending...",
      success: "Thank you! Your message has been sent. We'll contact you soon.",
      phone_label: "Phone", wa_label: "WhatsApp", email_label: "Email",
    },
    footer: { tagline: "Romanian-speaking support for UK flight compensation.", rights: "All rights reserved.", disclaimer: "ZborHelp is not a law firm. We provide assistance services for flight compensation claims.", support: "ZborHelp is an administrative support service for compensation claims regarding delayed, cancelled or denied-boarding flights.", terms: "Terms & Conditions", privacy: "Privacy Policy", cookies: "Cookies Policy" },
    wa: { float: "Message us on WhatsApp", msg: "Hi, I would like to check if I can claim compensation for a delayed or cancelled flight." },
    validation: "Please fill in the required fields.",
    error: "Something went wrong. Please try again.",
  },
};

const LanguageContext = createContext(null);

export function LanguageProvider({ children }) {
  const [lang, setLang] = useState("ro");
  const t = translations[lang];
  const toggle = () => setLang((l) => (l === "ro" ? "en" : "ro"));
  return <LanguageContext.Provider value={{ lang, setLang, toggle, t }}>{children}</LanguageContext.Provider>;
}

export const useLang = () => useContext(LanguageContext);

export const CONTACT = { phone: "+44 7466 077129", whatsapp: "+44 7466 077129", email: "contact@zborhelp.co.uk" };
